import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

// WARNING: this hook is old, use useTemplatesList instead!
export default function useTemplates(enterpriseId) {
  const [templates, setTemplates] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.enterprises.templates(enterpriseId), { params: { with_steps: false } })
      .then((response) => {
        setTemplates(response.data.data);
      });
  }, []);

  return templates;
}
